import styles from './DataTable.module.css'

/**
 * Visual table frame with horizontal overflow.
 * Does NOT define columns — each view owns its <thead> and <tbody>.
 */
export function DataTable({ children, className = '', compact = false }) {
  return (
    <div className={`${styles.frame} ${className}`}>
      <table className={`${styles.table} ${compact ? styles.compact : ''}`}>
        {children}
      </table>
    </div>
  )
}
